import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import SSPCommonModal from "../../../CommonComponents/SSPCommonModal/SSPCommonModal";
import {
  PageBar,
  SSPCommonButton,
  SSPCommonVideo,
} from "../../../CommonComponents";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Modal,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { post } from "../../../services";
import Cookies from "js-cookie";
const base = "https://";

const TripCosting = ({ token }) => {
  // console.log(" tripcostingID:", id);
  // console.log("tripcosting token:", token);
  const id = Cookies.get("ssp_domain_id");

  const getCurrentDate = () => {
    return new Date();
  };
  // const { id,token } = useParams();s
  const [modalOpener, setmodalOpener] = useState(false);
  const [message, setmessage] = useState("");
  const [location, setLocation] = useState("");
  const [date, setDate] = useState("");
  const [vehicleno, setVehicleno] = useState("");
  const [approvalstatus, setApprovalstatus] = useState("");
  const [selectedOption, setSelectedOption] = useState("Last 7 days");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const currentDate = getCurrentDate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [tripCostReason, setTripCostReason] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [viewReasonRow, setViewReasonRow] = useState(null);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [approvalStatusOptions, setApprovalStatusOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [contractTypeModalOpen, setContractTypeModalOpen] = useState(false);
  const [selectedContractType, setSelectedContractType] = useState("");
  const [selectedTripRate, setSelectedTripRate] = useState("");
  const [VariableRate, setVariableRate] = useState("");
  const [FixedRate, setFixedRate] = useState("");
  const [AgreedRate, setAgreedRate] = useState("");
  const [FixedCost, setFixedCost] = useState("");
  const [contractid, setcontractid] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabledRows, setDisabledRows] = useState({});
  const [loadingRow, setLoadingRow] = useState(null);
  const [vendorName, setVendorName] = useState("");
  const [storesData, setStoresData] = useState([]);
  const [storesModalOpen, setStoresModalOpen] = useState(false);

  const handleChangeLocation = (event) => {
    setLocation(event.target.value);
  };

  const handleChangeVehicleno = (event) => {
    setVehicleno(event.target.value);
  };
  const handleChangeApprovalstatus = (event) => {
    setApprovalstatus(event.target.value);
  };
  const today = currentDate;
  useEffect(() => {
    const currentDate = new Date();
    const lastWeekDate = new Date(
      currentDate.getTime() - 7 * 24 * 60 * 60 * 1000
    );
    setStartDate(lastWeekDate);
    setEndDate(currentDate);
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    const currentDate = new Date();
    const yesterdayDate = new Date(
      currentDate.getTime() - 1 * 24 * 60 * 60 * 1000
    );

    if (event.target.value === "Today") {
      setStartDate(currentDate);
      setEndDate(currentDate);
    } else if (event.target.value === "Yesterday") {
      setStartDate(yesterdayDate);
      setEndDate(yesterdayDate);
    } else if (event.target.value === "This Month") {
      setStartDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
      );
      setEndDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
      );
    } else if (event.target.value === "Last Month") {
      const lastMonthStart = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      const lastMonthEnd = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      );
      setStartDate(lastMonthStart);
      setEndDate(lastMonthEnd);
    } else if (event.target.value === "Last 7 days") {
      setStartDate(new Date(currentDate.getTime() - 6 * 24 * 60 * 60 * 1000));
      setEndDate(currentDate);
    } else if (event.target.value === "Last 30 days") {
      setStartDate(new Date(currentDate.getTime() - 29 * 24 * 60 * 60 * 1000));
      setEndDate(currentDate);
    } else if (event.target.value === "Custom") {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(
      date
        ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
        : null
    );
  };

  const handleEndDateChange = (date) => {
    setEndDate(
      date
        ? new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            23,
            59,
            59
          )
        : null
    );
  };

  const getMonthName = (date) => {
    const months = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[date.getMonth()];
  };
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = getMonthName(date);
    const day = ("0" + date.getDate()).slice(-2);
    return `${month},${day} ${year}`;
  };

  const [rows, setRows] = useState([]);
  const [originalRowsData, setOriginalRowsData] = useState([]);

  const rowFetch = async () => {
    setmessage("Fetching Data");
    let response = await post(
      base +
        "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/get_vendor_data",
      {
        vendor_id: parseInt(id),
      },
      true,
      false
    );
    if (response.data?.length) {
      const rowsData = response?.data?.map((row, index) => ({
        ...row,
        id: index + 1,
      }));
      setOriginalRowsData(rowsData);
      setRows(rowsData);
      const name = response.data.data[0].vendor_name;
      setVendorName(name);
    } else {
      setmessage("No Rows");
      setmodalOpener(true);
    }
  };
  useEffect(() => {
    rowFetch();
  }, []);

  useEffect(() => {
    if (rows?.length) {
      const uniqueLocationOptions = Array.from(
        new Set([...rows].map((row) => row.location_name))
      );
      const uniqueVehicleOptions = Array.from(
        new Set([...rows].map((row) => row.vehicle_number))
      );
      const uniqueApprovalStatusOptions = Array.from(
        new Set([...rows].map((row) => row.vendor_approval_status))
      );

      setLocationOptions(uniqueLocationOptions);
      setVehicleOptions(uniqueVehicleOptions);
      setApprovalStatusOptions(uniqueApprovalStatusOptions);
    }
  }, [originalRowsData]);

  const handleFilterData = () => {
    const formattedStartDate = startDate ? new Date(startDate) : null;
    const formattedEndDate = endDate ? new Date(endDate) : null;

    const filteredData = originalRowsData.filter((row) => {
      const rowDate = new Date(row.created_date);
      const locationMatch = location === "" || row.location_name === location;
      const dateMatch =
        !startDate ||
        (rowDate >= formattedStartDate && rowDate <= formattedEndDate);
      const vehiclenoMatch =
        vehicleno === "" || row.vehicle_number === vehicleno;
      const approvalstatusMatch =
        approvalstatus === "" || row.vendor_approval_status === approvalstatus;

      return (
        locationMatch && dateMatch && vehiclenoMatch && approvalstatusMatch
      );
    });
    // console.log('Filtered Data:', filteredData);
    setRows(filteredData);
  };

  const handleApprove = async (rowId) => {
    setLoadingRow(rowId);
    setDisabledRows((prev) => ({ ...prev, [rowId]: true }));
    // console.log("Handling approval for ID:", rowId);
    // await new Promise(resolve => setTimeout(resolve, 5000));
    const selectedRowData = rows.find((row) => row.id === rowId);

    if (!selectedRowData) {
      // console.error("Selected row data not found.");
      return;
    }
    try {
      // Step 1: Prepare the payload for /vendor_approval
      const approvalPayload = {
        rejection_reason: "",
        vendor_cost: selectedRowData.trip_cost,
        file_name: "",
        user_name: parseInt(id),
        approval_status: "Accepted",
        trip_id: selectedRowData.trip_id,
        fms_cost: selectedRowData.trip_cost,
      };
      // Step 2: Send the payload to /vendor_approval
      const approvalResponse = await post(
        base +
          "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/vendor_approval",
        approvalPayload,
        true,
        false
      );
      // console.log("Approval response:", approvalResponse);
      // Step 4: Update the rows with the approved status
      if (approvalResponse?.status === "success") {
        const updatedRows = rows.filter((row) => row.id !== rowId);
        setRows(updatedRows);
        setLoadingRow(null);
        // window.location.reload();
      } else {
        // Handle the case when the approval fails
        // console.error("Error during approval:", approvalResponse.message);
        setmessage("Error during approval. Please try again.");
        setmodalOpener(true);
        setLoadingRow(null);
        setDisabledRows((prev) => ({ ...prev, [rowId]: false }));
      }
    } catch (error) {
      // console.error("Error during approval:", error);
      setmessage("Error during approval.");
      setmodalOpener(true);
      setLoadingRow(null);
      setDisabledRows((prev) => ({ ...prev, [rowId]: false }));
    } finally {
      setLoadingRow(null);
    }
  };

  const handleReject = (id) => {
    setSelectedRow(id);
  };

  const handleRejectSubmission = async () => {
    if (!tripCostReason || !rejectionReason || !selectedFile) {
      setmessage(
        "Please provide all the details - trip cost, a rejection reason, and select a file."
      );
      setmodalOpener(true);
      return;
    }
    try {
      setLoading(true);
      // Step 1: Get the presigned URL
      const presignedUrlResponse = await post(
        base +
          "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/gen_pre_url",
        {
          doc_type: "reject_doc",
          doc_name: selectedFile.name,
        },
        "/gen_pre_url"
      );
      // console.log("presignedUrlResponse:", presignedUrlResponse);
      const presignedUrl = presignedUrlResponse?.body;
      // console.log("Presigned URL:", presignedUrl);

      // Step 2: Upload the file to the presigned URL
      const fileUploaded = await uploadFileWithPresignedUrl(
        selectedFile,
        presignedUrl
      );
      if (fileUploaded) {
        // console.log("File upload successful");

        // Step 3: Get additional details from /get_vendor_data API
        const selectedRowData = rows.find((row) => row.id === selectedRow);

        if (!selectedRowData) {
          // console.error("Selected row data not found.");
          return;
        }
        const approvalPayload = {
          vendor_id: parseInt(id),
          rejection_reason: rejectionReason,
          vendor_cost: tripCostReason,
          file_name: selectedFile.name,
          user_name: selectedRowData.vendor_id,
          approval_status: "Rejected",
          trip_id: selectedRowData.trip_id,
          fms_cost: selectedRowData.trip_cost,
        };

        // Step 3: Send the payload to /vendor_approval
        const approvalResponse = await post(
          base +
            "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/vendor_approval",
          approvalPayload,
          true,
          false
        );
        // console.log("Approval Response:", approvalResponse);
        // console.log("Before updating rows:", rows);

        const updatedRows = rows.map((row) =>
          row.id === selectedRow
            ? {
                ...row,
                vendor_approval_status: "Rejected",
                tripcost: tripCostReason,
                reason: rejectionReason,
                file: selectedFile,
              }
            : row
        );
        // console.log("After updating rows:", updatedRows);
        setRows(updatedRows);

        // Reset the state
        setSelectedRow(null);
        setTripCostReason("");
        setRejectionReason("");
        setSelectedFile(null);

        setTimeout(() => {
          window.location.reload();
        }, 4000);

        setmessage("File uploaded successfully!");
        setmodalOpener(true);
      } else {
        // console.error("File upload failed");
      }
    } catch (error) {
      // console.error("Error during file upload and approval:", error);
      setmessage("Error during file upload and approval. Please try again.");
      setmodalOpener(true);
    } finally {
      setLoading(false);
      setSelectedRow(null);
    }
  };

  const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
    try {
      const fileUploadData = new FormData();
      Object.keys(generatedUrl.fields).forEach((key) => {
        // console.log(key)
        fileUploadData.append(key, generatedUrl.fields[key]);
      });
      // console.log("File to Upload:", filetoUpload);
      fileUploadData.append("file", filetoUpload);

      // console.log(fileUploadData, generatedUrl?.url)
      const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);

      if (fileUploaded) {
        return true;
      } else {
        // console.error("File upload failed");
        return false;
      }
    } catch (error) {
      // console.error("Error during file upload:", error);
      throw error;
    }
  };

  const uploadFile = async (url, formData) => {
    try {
      const response = await axios.post(url, formData);

      if (response.status === 204) {
        // console.log('File upload successful with status 204');
        return true;
      }

      if (response.status >= 200 && response.status < 300) {
        // console.log('File upload successful');
        return true;
      } else {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      // console.error('Error during file upload:', error);
      throw error;
    }
  };

  const handleViewReason = (row) => {
    setViewReasonRow(row);
  };

  const handleDownloadFile = async (fileName) => {
    try {
      // Step 1: Get the presigned URL from the server
      const presignedUrlResponse = await post(
        base +
          "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/get_doc_url",
        {
          doc_type: "reject_doc",
          doc_name: fileName,
        },
        true,
        false
      );

      const presignedUrl = presignedUrlResponse?.data;
      if (!presignedUrl) {
        // console.error('Error: Empty presigned URL');
        return;
      }
      // Step 2: Use the presigned URL to download the file
      window.open(presignedUrl, "_blank");
    } catch (error) {
      // console.error('Error during file download:', error);
    }
  };

  const handleViewContractType = (
    contractType,
    triprate,
    contractId,
    variableRate,
    fixedRtae,
    fixedCost,
    agreedRate
  ) => {
    setSelectedContractType(contractType);
    setSelectedTripRate(triprate);
    setcontractid(contractId);
    setVariableRate(variableRate);
    setFixedRate(fixedRtae);
    setAgreedRate(agreedRate);
    setFixedCost(fixedCost);
    setContractTypeModalOpen(true);
  };
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "location_name", headerName: "Location", width: 170 },
    { field: "created_date", headerName: "Start Date", width: 130 },
    { field: "vehicle_number", headerName: "Vehicle No.", width: 130 },
    { field: "trip_id", headerName: "Trip Id ", width: 100 },
    { field: "kms_travelled", headerName: "KMs", width: 70 },
    {
      field: "contract_type",
      headerName: "Contract Type",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ whiteSpace: "normal" }}>
          <Button
            size="small"
            onClick={() =>
              handleViewContractType(
                params.row.contract_type,
                params.row.trip_rate_slab,
                params.row.contract_id_id,
                params.row.variable_rate,
                params.row.fixed_rate,
                params.row.fixed_cost,
                params.row.min_agreed_km
              )
            }
          >
            {params.row.contract_type}
          </Button>
        </div>
      ),
    },
    {
      field: "location_serviced",
      headerName: "Locations Serviced",
      width: 155,
      renderCell: (params) => (
        <Button
          size="small"
          onClick={() => handleLocationServicedClick(params.row.trip_id)}
          disabled={loading === params.row.trip_id}
        >
          {loading === params.row.trip_id ? (
            <CircularProgress size={24} />
          ) : (
            "View Stores"
          )}
        </Button>
      ),
    },
    {
      field: "toll_charges",
      headerName: "Toll Charges",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <CurrencyRupeeIcon fontSize="" />
          {params.value}
        </div>
      ),
    },
    {
      field: "trip_cost",
      headerName: "Trip Cost",
      width: 110,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <CurrencyRupeeIcon fontSize="" />
          {params.value}
        </div>
      ),
    },
    {
      field: "approval_status",
      headerName: "Approval Status",
      width: 200,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        const { vendor_approval_status, approval_status } = params.row;
        const showButtons =
          vendor_approval_status === "Pending" ||
          (vendor_approval_status === "Rejected" &&
            approval_status === "NTM Approved");
        const showRejectedState =
          vendor_approval_status === "Rejected" &&
          approval_status === "Vendor Rejected";
    
        return (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%" }}>
            {showButtons ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <Button
                  size="small"
                  style={{
                    backgroundColor: disabledRows[params.row.id]
                      ? "#ccc"
                      : "#6757fe",
                    color: "white",
                    width: "90px",
                    fontSize: "0.75rem",
                    padding: "2px 6px",
                  }}
                  onClick={() => handleApprove(params.row.id)}
                  disabled={
                    disabledRows[params.row.id] || loadingRow === params.row.id
                  }
                >
                  {loadingRow === params.row.id ? "Accepting..." : "Accept"}
                </Button>
                <Button
                  size="small"
                  disabled={loadingRow === params.row.id}
                  style={{
                    backgroundColor: "#e81500",
                    color: "white",
                    width: "90px",
                    fontSize: "0.75rem",
                    padding: "2px 6px",
                  }}
                  onClick={() => handleReject(params.row.id)}
                >
                  Reject
                </Button>
              </div>
            ) : showRejectedState ? (
              <div>
                <Typography
                  component="div"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  Rejected
                  <div>
                    <span
                      style={{
                        color: "blue",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => handleViewReason(params.row)}
                    >
                      View Reason
                    </span>
                  </div>
                </Typography>
              </div>
            ) : null}
          </div>
        );
      },
    }
    
    // {
    //   field: "approval_status",
    //   headerName: "Approval Status",
    //   width: 200,
    //   align: "left",
    //   headerAlign: "left",
    //   renderCell: (params) => {
    //     const { vendor_approval_status, approval_status } = params.row;
    //     const showButtons =
    //       vendor_approval_status === "Pending" ||
    //       (vendor_approval_status === "Rejected" &&
    //         approval_status === "NTM Approved");
    //     const showRejectedState =
    //       vendor_approval_status === "Rejected" &&
    //       approval_status === "Vendor Rejected";

    //     return (
    //       <div>
    //         {showButtons ? (
    //           <div style={{height:'100%',alignItems:'center',justifyContent:'center'}}>
    //             <div style={{ marginBottom: "5px" }}>
    //               <Button
    //                 size="small"
    //                 style={{
    //                   backgroundColor: disabledRows[params.row.id]
    //                     ? "#ccc"
    //                     : "#6757fe",
    //                   color: "white",
    //                   width: "90px",
    //                   fontSize: "0.75rem",
    //                   padding: "2px 6px",
    //                 }}
    //                 onClick={() => handleApprove(params.row.id)}
    //                 disabled={
    //                   disabledRows[params.row.id] ||
    //                   loadingRow === params.row.id
    //                 }
    //               >
    //                 {loadingRow === params.row.id ? "Accepting..." : "Accept"}
    //               </Button>
    //             </div>
    //             <div>
    //               <Button
    //                 size="small"
    //                 disabled={loadingRow === params.row.id}
    //                 style={{
    //                   backgroundColor: "#e81500",
    //                   color: "white",
    //                   width: "90px",
    //                   fontSize: "0.75rem",
    //                   padding: "2px 6px",
    //                 }}
    //                 onClick={() => handleReject(params.row.id)}
    //               >
    //                 Reject
    //               </Button>
    //             </div>
    //           </div>
    //         ) : showRejectedState ? (
    //           <div>
    //             <Typography
    //               component="div"
    //               style={{ color: "red", fontWeight: "bold" }}
    //             >
    //               Rejected
    //               <div>
    //                 <span
    //                   style={{
    //                     color: "blue",
    //                     textDecoration: "underline",
    //                     cursor: "pointer",
    //                   }}
    //                   onClick={() => handleViewReason(params.row)}
    //                 >
    //                   View Reason
    //                 </span>
    //               </div>
    //             </Typography>
    //           </div>
    //         ) : null}
    //       </div>
    //     );
    //   },
    // },
  ];
  const StoresDataTable = ({ data }) => (
    <>
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <div style={{ textAlign: "left" }}>Trip ID: {data.tripId}</div>
          <Divider
            style={{
              marginBottom: 15,
              marginTop: 5,
              borderTopWidth: 1,
              backgroundColor: "#9badbc",
            }}
          />
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                  Store Code
                </TableCell>
                <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
                  Store Name
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.locations.map((row) => (
                <TableRow key={row.id}>
                  <TableCell
                    component="th"
                    scope="row"
                    style={{ textAlign: "center" }}
                  >
                    {row.to_loc}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.loc_name}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </>
  );
  const handleLocationServicedClick = async (tripId) => {
    try {
      setLoading(tripId);
      let response = await post(
        base +
          "hjuxd3yf2iv3kd24m6ict6ycsa0famip.lambda-url.ap-south-1.on.aws/get_store_data",
        {
          trip_id: tripId,
        },
        true,
        false
      );
      if (response.data !== null) {
        const storeData = {
          tripId: tripId, // Storing tripId
          locations: response?.data.map((row, index) => ({
            ...row,
            id: index + 1,
          })),
        };
        setStoresData(storeData); // Assuming you have a state [storesData, setStoresData]
        setStoresModalOpen(true); // Assuming you have a state [storesModalOpen, setLocationModalOpen] for controlling the popup
      } else {
        // console.error('Failed to fetch location data');
      }
    } catch (error) {
      // console.error('Error fetching location data:', error);
    } finally {
      setLoading(null);
    }
  };
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#EEF2F7",
        }}
      >
        {/* Page Bar */}
        <PageBar
          text="Transport Billing : Trip Costing"
          vendorId={id}
          vendorName={vendorName}
        />

        <Card
          sx={{
            backgroundColor: "#EEF2F7",
            padding: "1.3rem",
          }}
        >
          <CardHeader
            p={2}
            sx={{
              backgroundColor: "#F8F8F9",
              fontWeight: "700",
              borderTopRightRadius: "5px",
              borderTopLeftRadius: "5px",
            }}
            title={" Filters"}
            titleTypographyProps={{
              sx: {
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "16px",
                color: "#0160F1",
              },
            }}
          />
          <Divider />
          <CardContent
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottomRightRadius: "5px",
              borderBottomLeftRadius: "5px",
              fontSize: 15,
              marginBottom: -5,
            }}
          >
            <Grid container Spacing={2}>
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <Typography sx={{ fontSize: 15 }}>Location :</Typography>
                <FormControl
                  sx={{
                    maxWidth: 250,
                    minWidth: 250,
                    marginTop: 1,
                    marginBottom: 1,
                  }}
                >
                  <Select
                    displayEmpty
                    size="small"
                    sx={{ fontSize: 15 }}
                    value={location}
                    label="Select Location"
                    onChange={handleChangeLocation}
                  >
                    <MenuItem value="">
                      <em sx={{ fontSize: 15 }}>Select Location</em>
                    </MenuItem>
                    {locationOptions.map((option) => (
                      <MenuItem
                        key={option}
                        value={option}
                        sx={{ fontSize: 15 }}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3} lg={3}>
                <Typography sx={{ fontSize: 15 }}>
                  Filter by Start Date :
                </Typography>
                <div>
                  <Select
                    size="small"
                    value={selectedOption}
                    onChange={handleOptionChange}
                    wordWrap="break-word"
                    renderValue={(selected) => {
                      switch (selected) {
                        case "This Month":
                          return `${getMonthName(today)} 1-${new Date(
                            today.getFullYear(),
                            today.getMonth() + 1,
                            0
                          ).getDate()}`;
                        case "Last Month":
                          return `${formatDate(startDate)} - ${formatDate(
                            endDate
                          )}`;
                        case "Last 7 days":
                          return `${formatDate(
                            new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000)
                          )} - ${formatDate(today)}`;
                        case "Last 30 days":
                          return `${formatDate(
                            new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000)
                          )} - ${formatDate(today)}`;
                        case "Yesterday":
                          return formatDate(
                            new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000)
                          );
                        case "Today":
                          return formatDate(new Date(today.getTime()));
                        default:
                          return selected;
                      }
                    }}
                    sx={{
                      maxWidth: 250,
                      minWidth: 250,
                      fontSize: 15,
                      marginTop: 1,
                      marginBottom: 1,
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      overflow: "hidden",
                    }}
                  >
                    <MenuItem value="Today" sx={{ fontSize: 15 }}>
                      Today
                    </MenuItem>
                    <MenuItem value="Yesterday" sx={{ fontSize: 15 }}>
                      Yesterday
                    </MenuItem>
                    <MenuItem value="This Month" sx={{ fontSize: 15 }}>
                      This Month
                    </MenuItem>
                    <MenuItem value="Last Month" sx={{ fontSize: 15 }}>
                      Last Month
                    </MenuItem>
                    <MenuItem value="Last 7 days" sx={{ fontSize: 15 }}>
                      Last 7 days
                    </MenuItem>
                    <MenuItem value="Last 30 days" sx={{ fontSize: 15 }}>
                      Last 30 days
                    </MenuItem>
                    <MenuItem value="Custom" sx={{ fontSize: 15 }}>
                      Custom
                    </MenuItem>
                  </Select>
                  <Box>
                    {selectedOption === "Custom" && (
                      <Grid container spacing={1} alignItems="center">
                        <Grid item>
                          <Typography sx={{ fontSize: 15 }}>
                            Start Date:
                          </Typography>
                          <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                          />
                        </Grid>
                        <Grid item>
                          <Typography sx={{ fontSize: 15 }}>
                            End Date:
                          </Typography>
                          <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            minDate={startDate}
                            maxDate={new Date()}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <Typography sx={{ fontSize: 15 }}>
                  Filter by Vehicle No :
                </Typography>
                <FormControl
                  sx={{
                    maxWidth: 250,
                    minWidth: 250,
                    marginTop: 1,
                    marginBottom: 1,
                  }}
                >
                  <Select
                    displayEmpty
                    size="small"
                    sx={{ fontSize: 15 }}
                    value={vehicleno}
                    label="Select Vehicle no"
                    onChange={handleChangeVehicleno}
                  >
                    <MenuItem value="">
                      <em sx={{ fontSize: 15 }}>Select Vehicle no</em>
                    </MenuItem>
                    {vehicleOptions.map((option) => (
                      <MenuItem
                        key={option}
                        value={option}
                        sx={{ fontSize: 15 }}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <Typography sx={{ fontSize: 15 }}>Approval Status :</Typography>
                <FormControl
                  sx={{
                    maxWidth: 250,
                    minWidth: 250,
                    marginTop: 1,
                    marginBottom: 1,
                  }}
                >
                  <Select
                    displayEmpty
                    size="small"
                    sx={{ fontSize: 15 }}
                    value={approvalstatus}
                    onChange={handleChangeApprovalstatus}
                  >
                    <MenuItem value="">
                      <em sx={{ fontSize: 15 }}>Approval Status</em>
                    </MenuItem>
                    {approvalStatusOptions.map((option) => (
                      <MenuItem
                        key={option}
                        value={option}
                        sx={{ fontSize: 15 }}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              lg={3}
              sx={{ marginTop: 1, marginBottom: 1 }}
            >
              <SSPCommonButton
                btnText={"Filter Data"}
                btnFunction={handleFilterData}
              />
            </Grid>
          </CardContent>
        </Card>

        <Card
          sx={{
            backgroundColor: "#EEF2F7",
            padding: "1.3rem",
          }}
        >
          <CardHeader
            p={2}
            sx={{
              backgroundColor: "#F8F8F9",
              fontWeight: "700",
              borderTopRightRadius: "5px",
              borderTopLeftRadius: "5px",
            }}
            title={" Completed Trips"}
            titleTypographyProps={{
              sx: {
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "16px",
                color: "#0160F1",
              },
            }}
            action={
              <>
                <Button onClick={() => window.location.reload()}>
                  Refresh Page
                </Button>
              </>
            }
          />
          <Divider />
          <CardContent
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottomRightRadius: "5px",
              borderBottomLeftRadius: "5px",
            }}
          >
            <Box
              sx={{
                display: { lg: "flex" },
              }}
            ></Box>
            <div>
              <div style={{ height: 700, width: "100%" }}>
                <DataGrid
                  // disableColumnMenu={true}
                  rowHeight={80}
                  showCellRightBorder={true}
                  sx={{
                    ".MuiDataGrid-columnHeaderTitle": {
                      fontWeight: "bold !important",
                    },
                    overflowX: "scroll",
                  }}
                  rows={rows}
                  columns={columns}
                  headerClassName="header-center"
                  rowsPerPageOptions={[10]}
                  pageSize={10}
                  getRowId={(row) => row.id}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                  componentsProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 500 },
                    },
                  }}
                />
              </div>
            </div>

            {contractTypeModalOpen && (
              <SSPCommonModal
                open={contractTypeModalOpen}
                handleOpenClose={setContractTypeModalOpen}
                message={
                  <>
                    <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                      Contract Details : {contractid}
                    </div>
                    <hr
                      style={{
                        borderTop: "1px solid #ccc",
                        marginBottom: "10px",
                      }}
                    />
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              colSpan={4}
                              style={{
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                            >
                              Contract Type:
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              {selectedContractType}
                            </TableCell>
                          </TableRow>
                          {selectedContractType === "Per Trip" && (
                            <>
                              <TableHead>
                                <TableRow>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    Contract Type
                                  </TableCell>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    Type
                                  </TableCell>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    KM Range
                                  </TableCell>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    Cost
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedTripRate.map((slab, index) => {
                                  const [rate, type, startRange, endRange] =
                                    slab.replace(/[()]/g, "").split(",");
                                  return (
                                    <TableRow key={index}>
                                      <TableCell>
                                        {selectedContractType}
                                      </TableCell>
                                      <TableCell>{type}</TableCell>
                                      <TableCell>{`${startRange} - ${endRange}`}</TableCell>
                                      <TableCell>{rate}</TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </>
                          )}
                          {selectedContractType === "Per KM" && (
                            <TableRow>
                              <TableCell style={{ fontWeight: "bold" }}>
                                Variable Rate:
                              </TableCell>
                              <TableCell>{VariableRate}</TableCell>
                            </TableRow>
                          )}
                          {selectedContractType ===
                            "Fixed+Variable with min km guarantee" && (
                            <TableRow>
                              <TableCell style={{ fontWeight: "bold" }}>
                                Fixed Cost
                              </TableCell>
                              <TableCell style={{ fontWeight: "bold" }}>
                                Variable Rate
                              </TableCell>
                              <TableCell style={{ fontWeight: "bold" }}>
                                Fixed Rate
                              </TableCell>
                              <TableCell style={{ fontWeight: "bold" }}>
                                Min Agreed Km
                              </TableCell>
                            </TableRow>
                          )}

                          {selectedContractType ===
                            "Fixed+Variable with min km guarantee" && (
                            <TableRow>
                              <TableCell>{FixedCost}</TableCell>
                              <TableCell>{VariableRate}</TableCell>
                              <TableCell>{FixedRate}</TableCell>
                              <TableCell>{AgreedRate}</TableCell>
                            </TableRow>
                          )}
                          {selectedContractType === "Fixed+Variable" && (
                            <>
                              <TableRow>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  Fixed Cost
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  Variable Rate
                                </TableCell>
                              </TableRow>

                              <TableRow>
                                <TableCell>{FixedCost}</TableCell>
                                <TableCell>{VariableRate}</TableCell>
                              </TableRow>
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                }
              />
            )}
            {storesModalOpen && (
              <SSPCommonModal
                open={storesModalOpen}
                handleOpenClose={setStoresModalOpen}
                message={<StoresDataTable data={storesData} />}
              />
            )}
            <div>
              {selectedRow !== null && (
                <Dialog
                  open={selectedRow !== null}
                  onClose={() => setSelectedRow(null)}
                  fullWidth
                >
                  <DialogTitle fontWeight={"bold"} fontSize={18}>
                    Reject Trip : Add estimated cost and supporting documents
                  </DialogTitle>
                  <DialogContent>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <Typography>
                        Trip Cost :{" "}
                        <b style={{ color: "red" }}>&nbsp;*&nbsp;</b>
                      </Typography>
                      <TextField
                        rows={1}
                        variant="outlined"
                        label="Trip Cost"
                        value={tripCostReason}
                        onChange={(e) => {
                          const enteredValue = e.target.value;
                          if (
                            /^\d*\.?\d*$/.test(enteredValue) ||
                            enteredValue === ""
                          ) {
                            setTripCostReason(enteredValue);
                          }
                        }}
                        style={{ marginLeft: "8px" }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <Typography>
                        Rejection Reason:
                        <b style={{ color: "red" }}>
                          &nbsp;&nbsp;&nbsp;&nbsp;*&nbsp;&nbsp;
                        </b>
                      </Typography>
                      <TextField
                        multiline
                        rows={4}
                        variant="outlined"
                        label="Rejection Reason"
                        value={rejectionReason}
                        onChange={(e) => setRejectionReason(e.target.value)}
                        style={{ marginLeft: "-35px", width: "100%" }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <Typography>
                        Upload File<b style={{ color: "red" }}>&nbsp;*&nbsp;</b>
                      </Typography>
                      <input
                        type="file"
                        onChange={(e) => setSelectedFile(e.target.files[0])}
                        style={{ marginLeft: "8px" }}
                      />
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setSelectedRow(null)}>Cancel</Button>
                    <Button
                      onClick={handleRejectSubmission}
                      disabled={loading}
                      variant="contained"
                      style={{ backgroundColor: "#6757fe" }}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </Button>
                  </DialogActions>
                </Dialog>
              )}
            </div>

            {viewReasonRow && (
              <Dialog
                open={viewReasonRow !== null}
                onClose={() => setViewReasonRow(null)}
              >
                <DialogTitle
                  sx={{ fontWeight: "bold", fontSize: 18 }}
                >{`Trip ${viewReasonRow.trip_id} : Rejection Details`}</DialogTitle>
                <Divider />
                <DialogContent>
                  <Typography>
                    Estimated Cost :
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <CurrencyRupeeIcon fontSize="" vertical-align="middle" />
                    {viewReasonRow.revised_cost}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "8px",
                    }}
                  >
                    <Typography sx={{ marginRight: "8px" }}>
                      Rejection
                      Reason:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </Typography>
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        borderRadius: "4px",
                        maxWidth: 300,
                        minWidth: 100,
                      }}
                    >
                      {viewReasonRow.rejection_reason}
                    </Box>
                  </div>
                  {viewReasonRow.rejection_doc_url && (
                    <>
                      <Typography
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "8px",
                        }}
                      >
                        Uploaded Documents :
                        <Button
                          color="primary"
                          startIcon={<GetAppIcon />}
                          onClick={() =>
                            handleDownloadFile(viewReasonRow.rejection_doc_url)
                          }
                        ></Button>
                      </Typography>
                    </>
                  )}
                </DialogContent>
              </Dialog>
            )}
            {modalOpener && (
              <SSPCommonModal
                open={modalOpener}
                handleOpenClose={setmodalOpener}
                message={message}
              />
            )}
          </CardContent>
        </Card>
        {/* Video  */}
        <SSPCommonVideo
          headerText={"Demo Video"}
          videoUrl={
            "https://www.youtube.com/embed/zJhH4Rgrto8?si=vRLlLSAlY0OEh4zc"
          }
        />
      </Box>
    </>
  );
};

export default TripCosting;
